import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Card, CardHeader, Collapse } from 'reactstrap';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import CustomCell from './subcomponents/CustomItemCell';
import Header from './subcomponents/Header';
import ItemCodes from '../../../config/SegCCodeDef.json';

const column1 = [
  {
    Header: 'CAGE',
    accessor: 'cage',
  },
  {
    Header: 'Part Number',
    accessor: 'partNumber',
  },
  {
    Header: <Header title="RNCC" tooltip={ItemCodes.RNCC.definition} />,
    accessor: 'rncc',
    Cell: cellProps => <CustomCell type="RNCC" value={cellProps.value} />,
  },

  {
    Header: <Header title="RNVC" tooltip={ItemCodes.RNVC.definition} />,
    accessor: 'rnvc',
    Cell: cellProps => <CustomCell type="RNVC" value={cellProps.value} />,
  },

  {
    Header: <Header title="DAC" tooltip={ItemCodes.DAC.definition} />,
    accessor: 'dac',
    Cell: cellProps => <CustomCell type="DAC" value={cellProps.value} />,
  },

  {
    Header: <Header title="RNSC" tooltip={ItemCodes.RNSC.definition} />,
    accessor: 'rnsc',
    Cell: cellProps => <CustomCell type="RNSC" value={cellProps.value} />,
  },

  {
    Header: <Header title="HCC" tooltip={ItemCodes.HCC.definition} />,
    accessor: 'hcc',
    Cell: cellProps => <CustomCell type="HCC" value={cellProps.value} />,
  },

  {
    Header: 'MSDS',
    accessor: 'msds',
  },
];

const Table = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Part Number Details{' '}
          {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/PNDetails.jsx